export const getUserAge = (userDOB) => {
  const currentYear = new Date().getFullYear();
  const formateDOB = new Date(userDOB);
  return currentYear - formateDOB.getFullYear();
};

export const getDateOnly = (dateString) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  const options = { year: "numeric", month: "short", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
};